import { delay, randomInt, graphQLPost } from '../utilities'
import { resolve, reject } from 'q';
import { string } from 'prop-types';
import { IUserData, IUser } from '../types/types';
import { identifier } from '@babel/types';

export default class User {
    static async getRole(): Promise<String> {
        
        const response = await graphQLPost(`{
                getCurrentUser { 
                    userRoles { 
                        id roles { id name } 
                    } 
                }
            }`, {});

        const roleIds = (response.getCurrentUser?.userRoles || []).map((e: any) => e.roles.id);
        const isAdmin = roleIds.indexOf(-1) != -1;
        
        //Ugly fix for principal
        const roleNames: string[] = (response.getCurrentUser?.userRoles || []).map((e: any) => e.roles.name);
        const isPrincipal = roleNames.filter(r => r.startsWith("SYS-REKTOR-")).length > 0;

        if (isAdmin)
            return 'ADMIN';
        if (isPrincipal)
            return 'PRINCIPAL';
        else 
            return 'USER';
    };

    static async getUserData(tag: string): Promise<IUserData[]> {
        try {
            const response
                = await graphQLPost(
                    `{ userData { id name data } }`, {}
                );
            return response.userData.filter((e: any) => e.name === tag).map((e: any) => ({ ...e, data: JSON.parse(e.data) })) as IUserData[];
        } catch (error) {
            console.error(error);
            throw("Fel vid hämtning av användardata...");
        }
    }
    
    static async upsertUserData(userData: IUserData): Promise<IUserData> {
        try {
            const formattedData = { 
                id: userData.id, 
                name: userData.name,
                data: JSON.stringify(userData.data)
            }
            
            let result : IUserData;

            if(userData.id === -1) {
                //INSERT
                const response = await graphQLPost(`mutation AddUserData($userData: UserDataInputType!) {
                    addUserData(userData: $userData) { id name data }
                }`, { userData: { name: formattedData.name, data: formattedData.data }});

                result = ({ ...response.addUserData, data: JSON.parse(response.addUserData.data) }) as IUserData;
            }
            else {
                //Update
                const response = await graphQLPost(`mutation SetUserData($userData: UserDataInputType!) {
                    setUserData(userData: $userData) { id name data }
                }`, { userData: formattedData });

                result = ({ ...response.setUserData, data: JSON.parse(response.setUserData.data) }) as IUserData;
            }

            return result;
        } catch (error) {
            console.error(error);
            throw("Fel vid sparning av användardata...");
        }
    }
    
    static async removeUserData(id: number): Promise<boolean> {
        try {
                
            const response = await graphQLPost(`mutation DeleteUserData($id: Int!) {
                deleteUserData(id: $id) { id name data }
            }`, { id });

            return true;
        } catch (error) {
            console.error(error);
            throw("Fel vid borttagning av användardata...");
        }
    }
}